import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/createClass";
import "core-js/modules/es6.regexp.replace.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import { call } from 'vuex-pathify';
import Platform from 'quasar/src/plugins/Platform.js';;
import Logger from 'js-logger';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { loadingFn } from "./utils";
import { i18n } from '@/boot/i18n';
import { queryParamFetch } from "../functions/utils";

var Setup = /*#__PURE__*/function () {
  function Setup() {
    _classCallCheck(this, Setup);

    this._$store;
    this._$q;
    this._$route;
    this._$router;
    this._device;
    this._digitalReceiptAvailable = false;
    this._eposEnabled;
    this._survey;
    this._surveyInProgress;
    this._tableNumberEntryAvailable = false;
    this._urlParams;
  }

  _createClass(Setup, [{
    key: "_getProperties",
    value: function _getProperties() {
      var _this = this;

      this._device = this._$store.getters['config/getDeviceType']; // TODO: replace with something legit when digital receipts are activated
      //! this.digitalReceiptAvailable = function() {
      //!   return false
      //! };

      this._surveyInProgress = function () {
        return _this._$store.getters['surveys/surveyInProgress'];
      };

      this._survey = function () {
        return _this._$store.getters['surveys/survey'](_this._surveyInProgress());
      };

      this._eposEnabled = function () {
        if (this._survey()) {
          return this._survey().eposEnabled;
        } else {
          return false;
        }
      }; // TODO: replace with something legit when table numbers are activated
      //! this.tableNumberEntryAvailable = function() {
      //!   return false
      //! };


      this._urlParams = function () {
        return _this._$store.getters['checkIn/urlParams'] || {};
      };
    }
  }, {
    key: "_updateTheme",
    value: function _updateTheme() {
      call('theme/updateTheme');
    }
  }, {
    key: "initialSetup",
    value: function () {
      var _initialSetup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_$store, _$router, _$q, _$route) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._$store = _$store;
                this._$router = _$router;
                this._$q = _$q;
                this._$route = _$route; // Set all the properties to be used throughout the setup

                this._getProperties(); // TODO: Better way for determining if its a pwa


                if (!process.env.APP_FOR_WEB) {
                  _context2.next = 8;
                  break;
                }

                this._setBranding();

                return _context2.abrupt("return");

              case 8:
                _context2.next = 10;
                return loadingFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _this2._checkBrowserSupport();

                          _this2._resetCheckInData(); // Logger.debug('Detected device with type: ' + this._device)
                          // Show loader while interacting with the API


                          if (!(_this2._device === 'web')) {
                            _context.next = 5;
                            break;
                          }

                          _context.next = 5;
                          return _this2._applyWebSetup();

                        case 5:
                          if (!(_this2._urlParams().pin || _this2._urlParams().pve || _this2._urlParams().checkId && (_$store.get('config').branchId || null))) {
                            _context.next = 8;
                            break;
                          }

                          _context.next = 8;
                          return _$store.dispatch('checkIn/fetchTransactionData');

                        case 8:
                          if (!(_$store.getters['checkIn/transactionRef'] && _$store.getters['checkIn/eposData'] && _this2._digitalReceiptAvailable)) {
                            _context.next = 13;
                            break;
                          }

                          // epos data and digital receipt available, redirect to digital receipt and return
                          // Logger.debug('epos data available and digital receipt available, redirecting to digital receipt')
                          _$router.push('/check_in/digital_receipt');

                          return _context.abrupt("return");

                        case 13:
                          if (!(!(_$store.getters['config/branchDetails'] || null) || _this2._urlParams()['inBranch'])) {
                            _context.next = 32;
                            break;
                          }

                          if (!_this2._tableNumberEntryAvailable) {
                            _context.next = 24;
                            break;
                          }

                          if (!(_this2._device === 'app')) {
                            _context.next = 20;
                            break;
                          }

                          // Redirect to team member enter table number
                          // Logger.debug('App => Redirecting to team member enters table number')
                          _$router.push('/check_in/team_member_table_number_entry');

                          return _context.abrupt("return");

                        case 20:
                          // Redirect to location check in
                          // Logger.debug('Web => Redirecting to location check in')
                          _$router.push('/check_in/location_check_in');

                          return _context.abrupt("return");

                        case 22:
                          _context.next = 32;
                          break;

                        case 24:
                          if (!(_this2._eposEnabled() && _this2._survey().showPinScreen)) {
                            _context.next = 32;
                            break;
                          }

                          if (!(_this2._device === 'app')) {
                            _context.next = 30;
                            break;
                          }

                          // Redirect to team member receipt pin entry
                          // Logger.debug('App => Redirecting to team member receipt pin entry')
                          _$router.push('/check_in/team_member_receipt_pin_entry');

                          return _context.abrupt("return");

                        case 30:
                          // Redirect to guest receipt pin entry
                          // Logger.debug('Web => Redirecting to guest receipt pin entry')
                          _$router.push('/check_in/guest_receipt_pin_entry');

                          return _context.abrupt("return");

                        case 32:
                          _$router.push('/check_in/get_started');

                          return _context.abrupt("return");

                        case 34:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initialSetup(_x, _x2, _x3, _x4) {
        return _initialSetup.apply(this, arguments);
      }

      return initialSetup;
    }()
  }, {
    key: "_checkBrowserSupport",
    value: function _checkBrowserSupport() {
      // Detect unsupported browsers.
      if (!Platform.is.ie) {
        return;
      } // Notify where you can get a supported browser from.


      this._$store.dispatch('toast/toast', {
        type: 'warning',
        html: true,
        // Enable html to permit links in the message.
        message: i18n.t('checkIn.checkIn.browserOutdated', ['<a href="https://browsehappy.com/" target="_blank">', '</a>']),
        timeout: 0
      });
    }
  }, {
    key: "_resetCheckInData",
    value: function _resetCheckInData() {
      this._$store.commit('answers/resetState');

      this._$store.commit('errors/resetState');

      this._$store.commit('checkIn/resetState');

      this._$store.commit('products/resetState');

      this._$store.commit('questions/resetState');

      this._$store.commit('responses/resetState');

      this._$store.commit('theme/resetState');

      if (this._device === 'web') {
        this._$store.commit('config/resetState');
      }
    }
  }, {
    key: "_badSurvey",
    value: function _badSurvey(error) {
      var route = '/error-404';
      Logger.error(error + ': redirecting to ' + route);

      this._$q.loading.hide(); // When loading the 404 page, don't try to resume an in-progress survey instead.
      // this._$store.dispatch('settings/resetAllModuleStates');


      if (process.env.DEV) {
        this._$store.dispatch('errors/display', {
          error: error,
          onClose: function onClose() {
            // Weird issues with routing to 404 so we'll just do a horrible thing outside of vue-router.
            window.location.replace("".concat(window.location.origin).concat(route)); // this._$router.push(route);
          }
        });
      } else {
        // Weird issues with routing to 404 so we'll just do a horrible thing outside of vue-router.
        window.location.replace("".concat(window.location.origin).concat(route)); // this._$router.push(route);
      }

      return;
    }
  }, {
    key: "_applyWebSetup",
    value: function () {
      var _applyWebSetup2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var getUrlParams, urlParamsSlug, configDownloaded;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Fetch params from the url, which includes the slug
                getUrlParams = queryParamFetch(this._$route, this._device);
                urlParamsSlug = getUrlParams.slug; // Redirect to `leave-feedback` page if we don't have a slug

                if (urlParamsSlug) {
                  _context3.next = 5;
                  break;
                }

                this._badSurvey(i18n.t('checkIn.errors.noSlug'));

                return _context3.abrupt("return");

              case 5:
                _context3.next = 7;
                return this._$store.dispatch('checkIn/fetchConfig', {
                  slug: urlParamsSlug,
                  showError: false
                });

              case 7:
                configDownloaded = _context3.sent;

                if (!(!configDownloaded || !this._$store.getters['config/companyKey'])) {
                  _context3.next = 11;
                  break;
                }

                // TODO: Handle errors here
                this._badSurvey(i18n.t('checkIn.errors.badSlug'));

                return _context3.abrupt("return");

              case 11:
                // Set the survey in progress to the survey's templateId
                this._$store.commit('surveys/surveyInProgress', this._$store.getters['surveys/surveyCount'] ? this._$store.getters['surveys/surveys'][0].templateId : 0); // Only *now* that we have fetched the config for the survey and have selected the survey
                // should we process the urlParams, as otherwise we won't have downloaded and set up the correct
                // configuration data which will allow it to call the api consistently without race conditions.


                _context3.next = 14;
                return this._$store.dispatch('checkIn/cleanParams', getUrlParams);

              case 14:
                Logger.debug('urlParams: ', getUrlParams); // Set the survey start time to now and generate a new guid to be used.

                this._$store.commit('checkIn/startTime', moment().format('YYYY-MM-DD HH:mm:ss'));

                this._$store.commit('checkIn/guid', uuidv4()); // Survey branding data


                this._setBranding();

                _context3.next = 20;
                return this._$store.dispatch('checkIn/setUrlParams');

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _applyWebSetup() {
        return _applyWebSetup2.apply(this, arguments);
      }

      return _applyWebSetup;
    }()
  }, {
    key: "_setBranding",
    value: function _setBranding() {
      if (!this._survey()) {
        return;
      }

      var branding = this._survey().branding || {};

      if (branding.font) {
        var font = branding.font;
        var fontFamily = font.substr(font.lastIndexOf('/') + 1).replace('+', ' '); // Font family follows last slash

        if (fontFamily) {
          this._$store.set('theme/theme@fontFamily', fontFamily);
        }
      } // Set colours


      if (branding.accentColour) {
        this._$store.set('theme/theme@accentColor', branding.accentColour);
      }

      if (branding.errorColour) {
        this._$store.set('theme/theme@dangerColor', branding.errorColour);
      }

      if (branding.primaryColour) {
        this._$store.set('theme/theme@primaryColor', branding.primaryColour);
      }

      if (branding.secondaryColour) {
        this._$store.set('theme/theme@secondaryColor', branding.secondaryColour);
      } // Set images


      if (branding.headerImage) {
        this._$store.set('theme/bgImage', branding.headerImage);
      }

      if (branding.backgroundImage) {
        this._$store.set('theme/bgImageShare', branding.backgroundImage);
      }

      if (branding.logoImage) {
        this._$store.set('theme/logo', branding.logoImage);
      } // Update theme to use survey branding


      this._updateTheme();
    }
  }]);

  return Setup;
}();

export { Setup as default };